import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class GlobalEventsManager {

    private _showNavBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showNavBarEmitter: Observable<boolean> = this._showNavBar.asObservable();

    private _emitLogout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public logoutEmitter: Observable<boolean> = this._emitLogout.asObservable();

    constructor() {}

    showNavBar(ifShow: boolean) {
      this._showNavBar.next(ifShow);
    }

    logout(ifLog: boolean) {
      this._emitLogout.next(ifLog);
    }

}
